import { createReducer, on } from '@ngrx/store';
import { CoreLocationDataActions, CoreUserActions, ManagedLocationCountActions, updateGdprConsent, updateGoogleMapsApiLoaded, updateSelectedAccount } from './core-actions';
import { CoreState, initialState } from './core-state';
import { locationDataAdapter } from './core-adapters';

export const coreStateReducer = createReducer(initialState,
    on(updateGoogleMapsApiLoaded, (state, { googleMapsApiLoaded }): CoreState => {
      return { ...state, googleMapsApiLoaded };
    }),
    on(CoreUserActions.updateUser, (state, { user }): CoreState => {
      return { ...state, user };
    }),
    on(CoreUserActions.updateUserDetails, (state, { userDetails }): CoreState => {
      return {
        ...state,
        userDetails: {
          username: userDetails?.username,
          language: userDetails?.language,
          userStatus: userDetails?.userStatus,
          role: userDetails?.role?.name,
          permissions: userDetails?.role?.permissions,
          userFeatures: userDetails?.userFeatures,
          gxWrapped: userDetails.gxWrapped,
          theJasonerEnabled: userDetails.theJasonerEnabled,
          accessibleGmbAccountIds: userDetails.accessibleGmbAccountIds,
          accessibleGmbLocationIds: userDetails.accessibleGmbLocationIds,
        },
        accounts: userDetails?.accounts,
        selectedAccount: userDetails?.accounts?.[0], // let's select the first array member by default
      };
    }),
    on(updateSelectedAccount, (state, { selectedAccount }): CoreState => ({
      ...state,
      selectedAccount,
      managedLocationCount: null, // reset count on account switch
      lastManagedLocationCountRefreshTimestamp: null, // reset timestamp on account switch
    })),
    on(CoreUserActions.updateUserLanguageSuccess, (state, { languageShort }): CoreState => ({
      ...state,
      userDetails: { ...state.userDetails, language: languageShort },
    })),
    on(updateGdprConsent, (state, { gdprConsent }): CoreState => ({
      ...state, gdprConsent,
    })),
    // should location data be updated on relevant page load, move loading state to component/local store
    on(CoreLocationDataActions.getLocationData, (state): CoreState => {
      return {
        ...state,
      };
    }),
    on(CoreLocationDataActions.getLocationDataSuccess, (state, { locationData }): CoreState => {
      return {
        ...state,
        locationData: locationDataAdapter.setAll(locationData, state.locationData),
      };
    }),
    on(CoreLocationDataActions.locationDataLoading, (state, { loading }): CoreState => {
      return {
        ...state,
        locationDataLoading: loading,
      };
    }),
    on(ManagedLocationCountActions.loadManagedLocationCountSuccess, (state, { count }): CoreState => ({
      ...state,
      managedLocationCount: count,
      lastManagedLocationCountRefreshTimestamp: new Date().getTime(),
    })),
    on(ManagedLocationCountActions.refreshManagedLocationCountSuccess, (state, { count }): CoreState => ({
      ...state,
      managedLocationCount: count,
      lastManagedLocationCountRefreshTimestamp: new Date().getTime(),
    })),
);
